'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UserIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function UserIcon(props) {
  return _react2.default.createElement(_Icon2.default, props, _react2.default.createElement('path', {
    d: 'M12,11 C10,11 9,9.43299662 9,7.5 C9,5.56700338 9.5,4 12,4 C14.5,4 15,5.56700338 15,7.5 C15,9.43299662 14,11 12,11 Z M8.0085302,19 C6.8992496,19 6,18.1052949 6,17 C6,15 7,12 12,12 C17,12 18,15 18,17 C18,18.1045695 17.0980496,19 15.9914698,19 L8.0085302,19 Z'
  }));
}